import React from "react";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";

import { IManagementStore } from "Stores/Management/types";
import PermissionGroupsContent from "./PermissionGroupsContent/PermissionGroupsContent";
import { Values } from "@src/Tools/Values";

interface IProps {
  management?: IManagementStore;
}

@inject("management")
@observer
class ManagePermissionGroups extends React.Component<IProps> {
  @observable isLoading: boolean = true;

  async componentDidMount() {
    try {
      if (this.props.management.activePermissions.length === 0) {
        await this.props.management.getActivePermissions();
      }
      await this.props.management.getPermissionGroups();
      document.title = Values.getLocalizationValue("permissionGroups");

      this.isLoading = false;
    } catch (error) {
      console.error(error);
    }
  }
  render() {
    return <div>{this.isLoading ? <div /> : <PermissionGroupsContent />}</div>;
  }
}

export default ManagePermissionGroups;
